import React, { useState, useEffect } from 'react';
import CoursesCarousel from '../courses-carousel';
import CoursesHorizontalList from '../courses-horizontal-list';

const lgBootstrapBreakpointWidth = 992;

const CoursesList = ({ topTitle, mainTitle, courses, onPlayCoursePreview, isLoading, isAvailableCourses }) => {
  const [showCoursesCarousel, setShowCoursesCarousel] = useState(window.innerWidth > lgBootstrapBreakpointWidth);

  useEffect(() => {
    const handleWindowResize = () => setShowCoursesCarousel(window.innerWidth > lgBootstrapBreakpointWidth);
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  if (showCoursesCarousel) {
    return (
      <CoursesCarousel
        topTitle={topTitle}
        mainTitle={mainTitle}
        courses={courses}
        onPlayCoursePreview={onPlayCoursePreview}
        isLoading={isLoading}
        isAvailableCourses={isAvailableCourses}
      />
    );
  }

  return (
    <CoursesHorizontalList
      topTitle={topTitle}
      mainTitle={mainTitle}
      courses={courses}
      onPlayCoursePreview={onPlayCoursePreview}
      isLoading={isLoading}
      isAvailableCourses={isAvailableCourses}
    />
  );
};

export default CoursesList;
